import React from 'react';
import { Quote } from 'lucide-react';
import reviewImage from '../assets/review-article.jpg';

const Review = () => {
  return (
    <section id="review" className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">昨年度の新聞評</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">第1回大会の様子が各紙で取り上げられました</p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-lg shadow-xl max-w-6xl mx-auto relative overflow-hidden">
          {/* Background Texture */}
          <div className="absolute inset-0 opacity-5 pointer-events-none" 
               style={{ backgroundImage: 'url("https://www.transparenttextures.com/patterns/paper.png")' }}>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="relative self-center">
              <img
                src={reviewImage}
                alt="Newspaper Article"
                className="w-full h-auto object-cover rounded shadow-md sepia-[.3]"
              />
              <div className="absolute bottom-0 left-0 bg-black/70 text-white px-4 py-2 text-sm">
                毎日新聞 4版 2025年9月24日（水）
              </div>
            </div>

            <div className="flex flex-col">
              <Quote className="text-gray-300 w-12 h-12 mb-4" />
              
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 font-serif border-b pb-4 border-gray-200">
                コンサートからの問い
              </h3>
              <p className="text-right text-sm text-gray-600 mb-6 font-serif">梅津 時比古</p>
              
              <div className="space-y-4 text-gray-700 font-serif leading-loose text-justify text-sm md:text-base h-[600px] overflow-y-auto pr-4 custom-scrollbar">
                <p>
                  コンクールの良いところは、参加者の演奏を誰かが聴いている、ということに尽きる。名も無い予選で、会場に数人しかいなくとも、その参加者の演奏を、初めて聴く人がいるだろう。情報なしにじかに接することで、聴く人、弾く人が得る感覚は、さまざまな発見に導く。それは“ショパンコンクール”が、各予選の映像を通じて全世界にもたらす、競争の興奮も加味された熱狂よりも地味には違いない。だが、弾くこと、聴くことの本質に通じる気がする。
                </p>
                <p>
                  過熱気味とも言えるコンクールブームの中、新しいコンクールが立ち上がった。音楽大学以外の大学のピアノサークルが参加する「第1回大学対抗ピアノ演奏チームコンテスト」（8月28日、東京芸術センター天空劇場）。参加したのは「熊本大学ピアノの会」「九大（九州大学）ピアノの会」「山形大学医学部ピアノ同好会」「横浜市立大学ピアノ会」「名古屋大学ピアノ同好会」の5チーム（プログラム掲載順）。
                </p>
                <p>
                  各チームは奏者と審査担当から成り、5人の奏者が「エチュード（ショパンから選択）」「古典ソナタ（第1楽章）」「連弾曲」「自由曲」の枠組みに分かれて演奏、審査担当が自チームを除き審査する。「エチュード」はさすがに最難曲はないが、単なる余技ではない。「古典ソナタ」ではベートーベン、ハイドンが並び「連弾曲」ではモーツァルトに集中。「自由曲」はシューマン、ショパン、ブラームス、リストの難曲が並ぶ。
                </p>
                <p>
                  音楽的な表現力もしっかりしており、ベートーベンのソナタ第3番第1楽章を弾いた「九大ピアノの会」の古賀麗さんは、音が生きていて、そのまま第2楽章も聴きたい、と切実に思った。
                </p>
                <p>
                  彼らと、一般のコンクールを目指す演奏家志望の若手との違いは何だろうか？ 演奏が“商品化”されているか否か、が思い浮かぶ。現代の演奏にはさまざまな内なる規制がある。コンクールが最たるものだが、自由、個性をうたいながらも、ベートーベンのある楽章のある箇所のペダルはこうしなければ減点される、ショパンの3拍子はああ弾くと良い点になる等々。それに徹すると、どこでも通用する一種の商品化が体内に備わる。
                </p>
                <p>
                  SNSの進化に伴い、コンサートの多くの評・感想がすぐ読めるようになった。当然そこにはさまざまな観点がある。信頼性の問題もある。すると、自分の耳で実際に演奏を聴かないと分からない、という要素が強まる。コロナ以降、人が集まることの意義も加わり、現在、コンサートの重要性が新たに問い直されている。
                </p>
                <p>
                  今回のコンテストは、全く商品化されていない在り方が、コンサートの原点を思わせた。優勝は九州大、準優勝は山形大。毎年1回行われる予定という。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </section>
  );
};

export default Review;
